export default "__VITE_ASSET__CSyn57F8__"